const translations = {
  "en": {
    "Subscription": "Subscription",
    "Update your card on edwealth.ai": "Update your card on edwealth.ai"
  },
  "zh-tw": {
    "Subscription": "訂閱",
    "Update your card on edwealth.ai": "於 edwealth.ai 更新您的卡片"
  }
};

export default translations;
